import * as React from 'react';
export const IcBasketballPlayer = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12.5 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6.5 7.32a1.002 1.002 0 00-.63-1.27l-2-.67a2 2 0 01-1-.79l-1.13-1.7a2.93 2.93 0 00-1.16-1l-1.52-.76a1 1 0 00-.8-.13l-2.84.71a3 3 0 00-2.18 2.21L5 11.76A1 1 0 005.76 13H6a1 1 0 001-.76l.71-2.83a1 1 0 01.73-.73l1.15-.29L6 20.73A1 1 0 006.73 22c.09.015.18.015.27 0a1 1 0 001-.73l2-7.21 1.76.59L10 20.73a1 1 0 00.73 1.27c.09.015.18.015.27 0a1 1 0 001-.73l1.7-6.07a2 2 0 00-1.29-2.45l-1.84-.61 1.06-3.71.45.23a.89.89 0 01.38.34l1.14 1.7a4 4 0 002.06 1.57l2 .68a1 1 0 001.34-.63zM18.5 14a1.5 1.5 0 100 3 1.5 1.5 0 000-3z'
      fill='currentColor'
    />
  </svg>
);
